import { render, staticRenderFns } from "./ProjectToothSelectorTab.vue?vue&type=template&id=3bb03ef8&scoped=true"
import script from "./ProjectToothSelectorTab.vue?vue&type=script&lang=js"
export * from "./ProjectToothSelectorTab.vue?vue&type=script&lang=js"
import style0 from "./ProjectToothSelectorTab.vue?vue&type=style&index=0&id=3bb03ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb03ef8",
  null
  
)

export default component.exports